import { createContext, useContext, useRef } from "react";

export interface PortalPreviewState {
  selectedProductId: string | null;
  activeStepIndex: number | null;
  executorView: string | null;
}

const DEFAULT_STATE: PortalPreviewState = {
  selectedProductId: null,
  activeStepIndex: null,
  executorView: null,
};

interface PortalPreviewStateContextValue {
  get(): PortalPreviewState;
  set(update: Partial<PortalPreviewState>): void;
}

const PortalPreviewStateContext =
  createContext<PortalPreviewStateContextValue | null>(null);

export function PortalPreviewStateProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const ref = useRef<PortalPreviewState>({ ...DEFAULT_STATE });

  const value = useRef<PortalPreviewStateContextValue>({
    get: () => ref.current,
    set: (update) => {
      ref.current = { ...ref.current, ...update };
    },
  }).current;

  return (
    <PortalPreviewStateContext.Provider value={value}>
      {children}
    </PortalPreviewStateContext.Provider>
  );
}

export function usePortalPreviewState(): PortalPreviewStateContextValue | null {
  return useContext(PortalPreviewStateContext);
}
